import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('change', this.handleToggle.bind(this))
  }

  async handleToggle(event) {
    const toggle = event.target
    const userId = toggle.dataset.userId
    const isApproved = toggle.checked
    const statusText = toggle.closest('.d-flex').querySelector('.status-text')
    const originalState = !isApproved

    try {
      const csrfToken = document.querySelector('[name="csrf-token"]').content
      const response = await fetch(`/superuser/dashboard/update_user_approval`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({
          user: {
            id: userId,
            approved: isApproved
          }
        })
      })

      if (response.ok) {
        // Update status text and classes
        statusText.textContent = isApproved ? 'Approved' : 'Pending'
        statusText.className = `status-text ${isApproved ? 'text-success' : 'text-danger'}`
      } else {
        // Revert toggle state on failure
        toggle.checked = originalState
        statusText.textContent = originalState ? 'Approved' : 'Pending'
        statusText.className = `status-text ${originalState ? 'text-success' : 'text-danger'}`
        console.error('Failed to update user status')
      }
    } catch (error) {
      // Revert toggle state on error
      toggle.checked = originalState
      statusText.textContent = originalState ? 'Approved' : 'Pending'
      statusText.className = `status-text ${originalState ? 'text-success' : 'text-danger'}`
      console.error('Error updating user status:', error)
    }
  }

  disconnect() {
    this.element.removeEventListener('change', this.handleToggle.bind(this))
  }
}
